import React, { useEffect, useState } from 'react';
import style from '../css/Navbar.module.css';
import { Link } from 'react-router-dom';
import { FaBars, FaXmark } from 'react-icons/fa6';
import Promo from './Promo';
import logo from '../assets/images/Hori_png.png';

function Navbar() {
	const [show, setShow] = useState(false);

	// ESC key to close menu
	useEffect(() => {
		const handleEsc = (e) => {
			if (e.key === 'Escape') setShow(false);
		};
		document.addEventListener('keydown', handleEsc);
		return () => document.removeEventListener('keydown', handleEsc);
	}, []);

	// Prevent scroll when menu is open
	useEffect(() => {
		document.body.style.overflow = show ? 'hidden' : 'auto';
	}, [show]);

	return (
		<div className={style.navbar}>
			{/* Desktop Nav */}
			{/* <Promo /> */}
			<div className={style.navbarContainer}>
				<Link to="/">
					<img src={logo} alt="Exporest" className={style.logo} />
				</Link>
				<div className={style.links}>
					<Link className={style.btn} to="/">
						Home
					</Link>
					<Link className={style.btn} to="/why">
						Why Exporest
					</Link>
					<Link className={style.btn} to="/about-us">
						About
					</Link>

					<Link className={style.btn} to="/contact">
						Contact
					</Link>
				</div>
				<div className={style.authLinks}>
					<Link className={style.btnlogin} to="/login">
						Login
					</Link>
					<Link className={style.btnRegi} to="/register">
						Get Started
					</Link>
				</div>
			</div>

			{/* Mobile Nav */}
			<div className={style.navbarMobile}>
				<Link to="/">
					<img src={logo} alt="Exporest" className={style.logo} />
				</Link>
				<div onClick={() => setShow(!show)}>
					{show ? (
						<FaXmark className={style.barIcon} />
					) : (
						<FaBars className={style.barIcon} />
					)}
				</div>
			</div>

			{/* Mobile Menu */}
			{show && (
				<div className={style.btnContainer}>
					<div className={style.moblinks}>
						<Link className={style.btn} to="/" onClick={() => setShow(false)}>
							Home
						</Link>
						<Link
							className={style.btn}
							to="/why"
							onClick={() => setShow(false)}
						>
							Why Exporest
						</Link>
						<Link
							className={style.btn}
							to="/about-us"
							onClick={() => setShow(false)}
						>
							About
						</Link>
				
						<Link
							className={style.btn}
							to="/contact"
							onClick={() => setShow(false)}
						>
							Contact
						</Link>
					</div>
					<div className={style.mobauthLinks}>
						<Link
							className={style.btnRegi}
							to="/register"
							onClick={() => setShow(false)}
						>
							Get Started
						</Link>
						<Link
							className={style.btnCall}
							to="tel:+917676838871"
							onClick={() => setShow(false)}
						>
							+91 76768 38871
						</Link>
						<Link
							className={style.btnlogin}
							to="/login"
							onClick={() => setShow(false)}
						>
							Login
						</Link>
					</div>
				</div>
			)}
		</div>
	);
}

export default Navbar;
